import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './ProductTag.scss'


const availableTagNames = [
  'addictive',
  'adventurous',
  'aquatic',
  'casual',
  'citrusy',
  'classic',
  'clean',
  'datenight',
  'elegant',
  'everyday',
  'fall',
  'feminine',
  'flirty',
  'floral',
  'fresh',
  'fruity',
  'girly',
  'hangingout',
  'light',
  'mysterious',
  'office',
  'party',
  'powdery',
  'sexy',
  'sophisticated',
  'spicy',
  'spring',
  'strong',
  'summer',
  'sweet',
  'trendsetter',
  'unique',
  'uplifting',
  'vacation',
  'warm',
  'winter',
  'woody',
  'workout',
]

const ProductTag = ({ className, tagClassName, name, img, lightGray, withTitle }) => {
  let tagStyle

  if (img) {
    tagClassName = cx(s.tagIcon, tagClassName)
    tagStyle = { backgroundImage: `url(${img})` }
  }
  else {
    const tagName = name.replace(' ', '').replace(/-/g, '_').toLowerCase()

    if (availableTagNames.includes(tagName)) {
      const tagIconName = `tag_${tagName}`

      tagClassName = cx(s.tagSpriteIcon, s[tagIconName], tagClassName)
    }
    else {
      console.warn(`There is no icon for tag with name "${name}"`)
      return null
    }
  }

  if (lightGray) {
    tagClassName = cx(tagClassName, {
      [s.lightGray]: lightGray,
    })
  }

  return (
    <div className={className}>
      <div className={tagClassName} style={tagStyle} />
      {
        withTitle && (
          <div className={s.title}>{name}</div>
        )
      }
    </div>
  )
}

ProductTag.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  img: PropTypes.string,
  withTitle: PropTypes.bool,
}

ProductTag.defaultProps = {
  withTitle: false,
}


export default ProductTag
